import { ClipboardCheckIcon, FileTextIcon } from '@/components/icons';
import { FormSection } from '@/components/ui/FormSection';
import type { Timesheet } from '../types';
import { TimesheetSatisfactionResults } from './TimesheetSatisfactionResults';

const formatDate = (value: string | null) =>
  value
    ? new Date(value).toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
    : '—';

export const TimesheetInformation = ({ timesheet }: { timesheet: Timesheet }) => (
  <div className="cra-information">
    <TimesheetSatisfactionResults responses={timesheet.satisfactionResponses ?? []} />
    <FormSection title="Mission et validation" icon={<ClipboardCheckIcon />}>
      <dl className="cra-facts">
        <div>
          <dt>Projet</dt>
          <dd>{timesheet.mission.projectName}</dd>
        </div>
        <div>
          <dt>Mission</dt>
          <dd>{timesheet.mission.title || '—'}</dd>
        </div>
        <div>
          <dt>Référence</dt>
          <dd>{timesheet.mission.reference || '—'}</dd>
        </div>
        <div>
          <dt>Client</dt>
          <dd>{timesheet.mission.clientName || '—'}</dd>
        </div>
        <div>
          <dt>Créé le</dt>
          <dd>{formatDate(timesheet.createdAt)}</dd>
        </div>
        <div>
          <dt>Période de mission</dt>
          <dd>
            {formatDate(timesheet.mission.startDate)} →{' '}
            {timesheet.mission.endDate ? formatDate(timesheet.mission.endDate) : 'Sans date de fin'}
          </dd>
        </div>
        <div>
          <dt>Soumis le</dt>
          <dd>{formatDate(timesheet.submittedAt)}</dd>
        </div>
        <div>
          <dt>Validé le</dt>
          <dd>{formatDate(timesheet.validatedAt)}</dd>
        </div>
        <div>
          <dt>Dernier renvoi</dt>
          <dd>{formatDate(timesheet.rejectedAt)}</dd>
        </div>
        <div>
          <dt>Revu par</dt>
          <dd>
            {timesheet.reviewedBy
              ? [timesheet.reviewedBy.firstName, timesheet.reviewedBy.lastName]
                  .filter(Boolean)
                  .join(' ') || timesheet.reviewedBy.email
              : '—'}
          </dd>
        </div>
        <div>
          <dt>Dernière mise à jour</dt>
          <dd>{formatDate(timesheet.updatedAt)}</dd>
        </div>
      </dl>
    </FormSection>
    <FormSection title="Commentaires et retour de mission" icon={<FileTextIcon />}>
      <div className="cra-notes">
        <div>
          <h3>Commentaire du CRA</h3>
          <p>{timesheet.comment || 'Aucun commentaire renseigné.'}</p>
        </div>
        {timesheet.feedback?.comment && (
          <div>
            <h3>Retour du consultant</h3>
            <p>{timesheet.feedback.comment}</p>
          </div>
        )}
        {timesheet.feedback && (
          <dl className="cra-facts">
            <div>
              <dt>Satisfaction ESN</dt>
              <dd>{timesheet.feedback.esnSatisfaction?.label || '—'}</dd>
            </div>
            <div>
              <dt>Satisfaction mission</dt>
              <dd>{timesheet.feedback.missionSatisfaction?.label || '—'}</dd>
            </div>
          </dl>
        )}
      </div>
    </FormSection>
  </div>
);
